var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ApiContext from '../contexts/apiContext';
import { softDeleteChat } from '../api';
import ErrorDialog from './ErrorDialog';
var DeleteChatButton = function (_a) {
    var chat = _a.chat, dispatch = _a.dispatch;
    var _b = useState(false), dialogOpen = _b[0], setDialogOpen = _b[1];
    var _c = useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var deleteChat = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, softDeleteChat(apiBaseUrl, id)];
                case 1:
                    _a.sent();
                    dispatch({
                        state: {
                            id: id
                        },
                        type: 'delete_chat'
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error(err_1);
                    setErrorMessage("There's been an error adding a chat, please check your connection and try again");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseClick = function () { return setDialogOpen(false); };
    var handleConfirmClick = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, deleteChat(chat.id)];
    }); }); };
    var handleDeleteChatClick = function (e) {
        e.stopPropagation();
        setDialogOpen(true);
    };
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    return (_jsxs(_Fragment, { children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), _jsxs(Dialog, { open: dialogOpen, onClose: handleCloseClick, children: [_jsx(DialogTitle, { children: "Delete chat" }), _jsx(DialogContent, { children: _jsxs(DialogContentText, { children: ["Are you sure you want to delete the chat ", chat.name, ", created on ", new Date(chat.createdAt).toLocaleString(), "?"] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleConfirmClick, children: "OK" }), _jsx(Button, { onClick: handleCloseClick, autoFocus: true, children: "Cancel" })] })] }), _jsx(IconButton, { size: "small", component: "div", onClick: handleDeleteChatClick, sx: { p: 0 }, children: _jsx(DeleteIcon, {}) })] }));
};
export default DeleteChatButton;
